import { Component, ViewEncapsulation, input } from '@angular/core';

export type StatDisplayAlign = 'start' | 'center';

@Component({
  selector: 'ds-stat-display',
  templateUrl: './stat-display.html',
  styleUrl: './stat-display.scss',
  encapsulation: ViewEncapsulation.None,
})
export class StatDisplayComponent {
  readonly value = input.required<string>();
  readonly label = input.required<string>();
  readonly context = input<string>();
  readonly align = input<StatDisplayAlign>('start');
}
